import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getToken } from '@/utils/auth';

const API = process.env.REACT_APP_BACKEND_URL;

// Canonical (non-white-label) brand always carries the ™ mark.
function normalizeBrand(name) {
  if (!name) return 'SAFER-i™';
  if (name === 'SAFER-i' || name === 'SAFER-I') return 'SAFER-i™';
  return name;
}

const BrandingContext = createContext({
  brandName: 'SAFER-i™',
  logoUrl: null,
  loading: true,
  refresh: () => {}
});

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({ brandName: 'SAFER-i™', logoUrl: null });
  const [loading, setLoading] = useState(true);

  const fetchBranding = useCallback(async () => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await fetch(`${API}/api/branding`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setBranding({
          brandName: normalizeBrand(data.brand_name),
          logoUrl: data.logo_url || null
        });
      }
    } catch {
      // keep defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBranding();
  }, [fetchBranding]);

  return (
    <BrandingContext.Provider value={{ ...branding, loading, refresh: fetchBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
